import script from "./PlayerSite.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerSite.vue?vue&type=script&setup=true&lang=js"

import "./PlayerSite.vue?vue&type=style&index=0&id=ef0533b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.0_postcss@8.5.31_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef0533b2"]])

export default __exports__